import React, { useState, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import apiService from '../../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from './MenuVerDiagnosticos';
import ButtonsMenu from '../../Utils/ButtonsMenu';
import { useAuth } from './../../../Auth/AuthContext';

export default function DiagnosticoAlbergue(){
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const {token} = useAuth();
    const [datosAlbergue, setDatosAlbergue] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10); 
    const [swalProps, setSwalProps] = useState();
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, []);
    const fetchData = async (page, rowsPerPage) => {
        let url = `/caracterizacion/diagnosticos/listardatoalbergue?page=${page}&limit=${rowsPerPage}`;
        try {
            setCargando(true);
            const response = await apiService.get(url, token);
            const result = await response.data;
            setDatosAlbergue(result.data);
            setTotalRows(result.meta.total);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
        
        
    };
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <button onClick={() => verAtencionesPersona(row)} 
                        style={{backgroundColor: 'skyblue'}} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Ver atenciones de la persona">
                <i className="fas fa-list nav-icon"></i>
                </button>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '3%'
        },
        { name: 'Identificación', selector: row => row.per_idpersona, sortable: true, width:'11%' },
        { name: 'Nombre', selector: row => row.nombre, sortable: true, width: '20%'},
        { name: 'Forma de salida', selector: row => row.alb_formasalida, sortable: true, width: '10%'},
        { name: 'Fecha de declaración', selector: row => row.alb_fechadeclaracion, sortable: true, width: '10%'},
        { name: 'Código de declaración', selector: row => row.alb_codigodeclaracion, sortable: true, width: '10%'},
        { name: 'Resolución de valoración', selector: row => row.alb_resvalora, sortable: true, width: '10%'},
        { name: 'Fecha de notificación resolución', selector: row => row.alb_fechanotificares, sortable: true, width: '10%'},
        { name: 'Fecha límite de resolución', selector: row => row.alb_fechaliminteres, sortable: true, width: '10%'},
        { name: 'Fecha de recurso de reposición en subsidio de apelación', selector: row => row.alb_fecharecursoreposub, sortable: true, width: '10%'},
        { name: 'Fecha límite de resolución del recurso', selector: row => row.alb_fechalimiterecurso, sortable: true, width: '10%'},
        { name: 'Resolución de recurso de reposición', selector: row => row.alb_fecharecursorepo, sortable: true, width: '10%'},
        { name: 'Fecha de notificación recurso', selector: row => row.alb_fechanotirecurso, sortable: true, width: '10%'},
        { name: 'Resolución de apelación', selector: row => row.alb_resoapelacion, sortable: true, width: '10%'},
        { name: 'Fecha de notificación apelación', selector: row => row.alb_fechanotiapelacion, sortable: true, width: '10%'},
        { name: 'Fecha de tutela', selector: row => row.alb_fechatutela, sortable: true, width: '10%'},
        { name: 'Medida preventiva albergue', selector: row => row.alb_medidapreventiva, sortable: true, width: '10%'},
        { name: 'Fecha de impugnación', selector: row => row.alb_fechaimpugnacion, sortable: true, width: '10%'},
        { name: 'Revocatoria', selector: row => row.alb_revocatoria, sortable: true, width: '10%'}
    ];
    function verAtencionesPersona (row){
        navigate(`/consulta/consultaatenciones/${row.per_idpersona}`);
    };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };
    async function exportarCSV() {
        setCargando(true);
        const url = `/caracterizacion/diagnosticos/listardatoalbergue?page=0&limit=0&csv=true`;

        try {
            const response = await apiService.get(url, token, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', 'datos_albergue.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Diagnostico albergue</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={`/`} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={`/consultas/verdiagnosticos`} >Diagnosticos</NavLink></li>
                        <li className="breadcrumb-item active"> albergue</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos></MenuVerDiagnosticos>
                    <div className="row">
                        <div className="col-md-12">
                            <ButtonsMenu data={datosAlbergue} titulo="Albergue" exportarCSV={exportarCSV}/>
                            <div className="card-body table-responsive p-0">
                                <DataTable
                                    title="Albergue"
                                    columns={columns}
                                    data={datosAlbergue}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}